import { useState, useEffect } from 'react';
import { api } from '../contexts/AuthContext';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Software from '../components/Software';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
    const [content, setContent] = useState({});
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [contentRes, productsRes] = await Promise.all([
                    api.get('/api/content'),
                    api.get('/api/products')
                ]);
                
                // Convert content array to object keyed by 'key'
                const contentObj = {};
                contentRes.data.forEach(item => {
                    contentObj[item.key] = item;
                });
                setContent(contentObj);
                setProducts(productsRes.data);
            } catch (error) {
                console.error('Failed to fetch data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <div className="min-h-screen bg-background-base flex items-center justify-center">
                <div className="text-text-muted">Loading...</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-background-base" data-testid="home-page">
            <Navbar />
            <Hero content={content} />
            <About content={content} />
            <Software products={products} />
            <Contact />
            <Footer />
        </div>
    );
};

export default Home;
